import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingInventoryStatus': false,
  'inventoryStatus': {},
  'loadingAmountDetail': false,
  'amountDetail': {},
  'loadingLinesInfo': false,
  'lineInfo': {},
  'loadingLinesDetail': false,
  'linesDetail': {
    'received': [],
    'backOrder': [],
    'dispatched': [],
  },
  'downloading': false,
  'urlLinesFile': {
    'received': '',
    'backOrder': '',
    'dispatched': '',
  },
  'searchParam': {
    'received': '',
    'backOrder': '',
    'dispatched': '',
  },
};

const updateLinesDetail = (linesDetail, lineType, data) => {
  const newLinesDetail = {...linesDetail};
  const detail = data && data.detail ? data.detail : [];

  newLinesDetail[lineType] = detail;
  return newLinesDetail;
};

const updateUrlFile = (urlLinesFile, lineType, data) => {
  const newUrls = {...urlLinesFile};
  newUrls[lineType] = data;
  return newUrls;
};

export const cpd = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_LINES_INFO]: (state, action) => ({
      ...state,
      'loadingInventoryStatus': false,
      'inventoryStatus': {},
      'loadingAmountDetail': false,
      'amountDetail': {},
      'loadingLinesInfo': false,
      'lineInfo': {},
      'loadingLinesDetail': false,
      'linesDetail': {
        'received': [],
        'backOrder': [],
        'dispatched': [],
      },
      'downloading': false,
      'urlLinesFile': '',
    }),
    [ActionTypes.CLEAR_URL_LINES_FILE]: (state, action) => ({
      ...state,
      'urlLinesFile': {
        'received': '',
        'backOrder': '',
        'dispatched': '',
      },
    }),
    [ActionTypes.FETCHING_INVENTORY_STATUS]: (state, action) => ({
      ...state,
      'loadingInventoryStatus': true,
    }),
    [ActionTypes.FETCHED_INVENTORY_STATUS]: (state, action) => ({
      ...state,
      'inventoryStatus': action.response.data,
      'loadingInventoryStatus': false,
    }),
    [ActionTypes.FETCHED_INVENTORY_STATUS_FAILED]: (state, action) => ({
      ...state,
      'inventoryStatus': {},
      'loadingInventoryStatus': false,
    }),
    [ActionTypes.FETCHING_INVENTORY_STATUS_DETAIL]: (state, action) => ({
      ...state,
      'loadingAmountDetail': true,
    }),
    [ActionTypes.FETCHED_INVENTORY_STATUS_DETAIL]: (state, action) => ({
      ...state,
      'loadingAmountDetail': false,
      'amountDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_INVENTORY_STATUS_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingAmountDetail': false,
      'amountDetail': {},
    }),
    [ActionTypes.FETCHING_LINES_INFO]: (state, action) => ({
      ...state,
      'loadingLinesInfo': true,
    }),
    [ActionTypes.FETCHED_LINES_INFO]: (state, action) => ({
      ...state,
      'loadingLinesInfo': false,
      'lineInfo': action.response.data,
    }),
    [ActionTypes.FETCHED_LINES_INFO_FAILED]: (state, action) => ({
      ...state,
      'loadingLinesInfo': false,
      'lineInfo': {},
    }),
    [ActionTypes.FETCHING_LINES_INFO_WITH_DETAIL]: (state, action) => ({
      ...state,
      'loadingLinesDetail': true,
    }),
    [ActionTypes.FETCHED_LINES_INFO_WITH_DETAIL]: (state, action) => ({
      ...state,
      'loadingLinesDetail': false,
      'linesDetail': updateLinesDetail(state.linesDetail, action.payload, action.response.data),
    }),
    [ActionTypes.FETCHED_LINES_INFO_WITH_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingLinesDetail': false,
      'linesDetail': updateLinesDetail(state.linesDetail, action.payload, []),
    }),
    [ActionTypes.DOWNLOADING_LINES_FILE]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_LINES_FILE]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlLinesFile': updateUrlFile(state.urlLinesFile, action.payload, action.response.data),
    }),
    [ActionTypes.DOWNLOADED_LINES_FILE_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlLinesFile': updateUrlFile(state.urlLinesFile, action.payload, ''),
    }),
    [ActionTypes.SET_SEARCH_PARAM_DETAIL]: (state, action) => {
      const tempSearchParam = {...state.searchParam};
      tempSearchParam[action.payload.key] = action.payload.search;
      return ({...state, 'searchParam': tempSearchParam});
    },
  })(state, action);
};
